/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ---------------------------------------------------------------------------------------------
 */

import { style } from 'typestyle';

export function teamsAppValidatorStyles(themedColors: any) {
  return {
    divider: style({
      height: '1px',
      background: themedColors.dividerColor,
      borderRadius: '0px'
    }),
    tabs: {
      uploadManifest: {
        common: style({
          maxWidth: '600px',
          padding: '24px 20px',
          marginTop: '27px',
          marginBottom: '16px',
          background: themedColors.panelFileUploadBackground,
          boxShadow: themedColors.panelFileUploadShadowBackground,
          borderRadius: '4px',
        }),
        uploadForm: {
          common: style({
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-end',
            flexWrap: 'wrap',
          }),
          radioGroup: style({
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            $nest: {
              'label': {
                cursor: 'pointer',
              }
            }
          }),
          radioBtn: style({
            paddingTop: '0.25rem',
            $nest: {
              ':nth-child(1)':{
                color: themedColors.panelFileUploadLabelColor,
                fontSize: '11px',
                height: '15px',
                letterSpacing: '0px',
              },
              ':nth-child(3)': {
                borderRadius: '7px',
                border: '1px solid rgb(151, 151, 151)',
                height: '14px',
                width: '14px',
              }
            }
          }),
          col: style({
            display: 'flex',
            flexDirection: 'column',
          }),
          label: style({
            height: '15px',
            color: themedColors.panelFileUploadLabelColor,
            fontSize: '11px',
            letterSpacing: '0px',
          }),
          inputFile: style({
            color: themedColors.panelFileUploadLabelColor,
            padding: '0px',
            $nest: {
              'i': {
                margin: '0px'
              }
            }
          }),
          selectEnvironment: style({
            color: themedColors.panelFileUploadLabelColor,
            marginTop: '11px',
            width: '213px',
          }),
          enironmentNotFound: style({
            color: themedColors.panelFileUploadLabelColor,
            marginTop: '11px',
            width: '213px',
            height: '32px',
            fontSize: '13px',
            borderRadius: '0px',
          })
        }
      },
      validationResults: {
        spinner: style({
          color: themedColors.validationResultsSpinnerColor,
        }),
        common: style({
          background: themedColors.panelValidationResultBackground,
          boxShadow: '0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13), 0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.11)',
          borderRadius: '0px',
        }),
        boxHeader: {
          common: style({
            padding: '18px 24px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }),
          title: style({
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            color: themedColors.panelHeaderText,
            fontSize: '18px',
            fontWeight: 'bold',
            letterSpacing: '0px',
          }),
          print: style({
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            cursor: 'pointer',
            float: 'right',
            color: themedColors.panelValidationResultPrintColor,
            fontSize: '14px',
            letterSpacing: '0px',
          })
        },
        infoPanel: {
          common: style({
            flexWrap: 'wrap',
            display: 'flex',
            flexDirection: 'row',
          }),
          col: {
            common: style({
              padding: '4px 35px'
            }),
            header: style({
              paddingTop: '12px',
              height: '16px',
              color: 'rgb(152, 152, 152)',
              fontSize: '12px',
              fontWeight: 600,
              letterSpacing: '0px',
            }),
            content: style({
              height: '20px',
              color: themedColors.panelInfoColContentColor,
              fontSize: '14px',
              fontWeight: 600,
              letterSpacing: '0px',
              lineHeight: '20px',
            })
          }
        },
        result: {
          common: style({
            display: 'flex',
            flexDirection: 'column',
          }),
          rowHeader: style({
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            margin: "17px 24px",
            color: 'rgb(152,152,152)'
          }),
          row: {
            common: style({
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              padding: '13px 24px',
              color: 'rgb(152, 152, 152)',
              $nest: {
                '&:nth-child(even)': {
                  background: themedColors.panelResultEvenRowBackground
                },
                '&:nth-child(odd)': {
                  background: themedColors.panelResultOddRowBackground
                }
              },
            }),
            colFirst: style({
              flexGrow: 1.5,
              width: '106px',
              color: themedColors.panelResultColumnColor,
              fontSize: '14px',
              letterSpacing: '0px',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'baseline',
              wordBreak: 'break-word',
            }),
            fixItLink: style({
              color: themedColors.panelResultFixItLinkColor,
              textDecoration: 'none',
              fontSize: '14px',
            }),
            header: style({
              color: 'rgb(152, 152, 152)',
              fontSize: '12px',
              fontWeight: 600,
              letterSpacing: '0px',
            })
          }
        }
      }
    }
  }
}